export const Fonts = {
    Primary: `"WorkSans", Helvetica, sans-serif`,
    Secondary: `"Rubik", Helvetica, sans-serif`,
    Rubik: `"Rubik", Helvetica, sans-serif`,
};
